import { render } from "./AmenitiesView.vue?vue&type=template&id=6e90d66a"
import script from "./AmenitiesView.vue?vue&type=script&lang=js"
export * from "./AmenitiesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__